import {LOGIN_ACTION , SET_RUNNING_CACHE , LOG_OUT_ACTION , SET_LOGIN_USER_DETAILS,VERIFY_OTP, SET_SERVER_URL, SET_PREPAID_OTA_AGENT_ID, SET_PREPAID_OTA_TRAVELS_ID} from './action-types';
import { USER_LOGIN_URL , VERIFY_OTP_URL, GET_SERVER_URL_BY_USER_NAME_URL, GET_TRAVELS_DETAILS_FOR_DAFIDY_PREPAID_OTA_URL} from '../utils/api-url';
import { postCall } from "../utils/network.util";
import { SUCCESS_STATUS } from "../utils/constant";
import { isValid } from "../utils/utilities";

export const userLogin = (userName,password,accessCode,onSuccess=()=>{

}) => {
    return {
        type: LOGIN_ACTION,
        payload: {
            url:USER_LOGIN_URL,
            api:postCall,
            apiPayload:{
                loginInfo:{
                    userName,
                    password,
                    access_code:accessCode
                }
            },
            onSuccess:onSuccess
        }
    }
  }
   
export const logoutAction=()=>{
    return {
        type:LOG_OUT_ACTION
    }
}

export const setRunSplashScreen =(bool)=>{
    return {
        type:SET_RUNNING_CACHE,
        payload:bool
    }
}

export const setLoginUserDetails = (payload)=>{
    return {
        type:SET_LOGIN_USER_DETAILS,
        payload:payload
    }
}

export const verifyOtp = (otp,phno,onSuccess)=>{
    return {
        type:VERIFY_OTP,
        payload:{
            url:VERIFY_OTP_URL,
            api:postCall,
            apiPayload:{
                otp:otp,
                key:phno
            },
            onSuccess:onSuccess
        }
    }
}


export const getServerUrlByUserName = (userName, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(GET_SERVER_URL_BY_USER_NAME_URL, {userName}).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            onSuccess(response.payload.Payload);
        } else {
            onSuccess(null);
        }
    });
}

export const setServerUrl = (serverUrl) => {
    return {
        type: SET_SERVER_URL,
        payload: serverUrl
    }
}

/**
 * Resolves the operator's travels server (by operatorCode, via the central admin
 * server) and starts the Razorpay OAuth flow on THAT server.
 *
 * The Razorpay authorize page is public (no login), so global.serverUrl / the
 * stored api_base_urls are empty and the module-level RAZORPAY_OAUTH_URL would
 * fall back to the default travels server. Razorpay config lives on the operator's
 * own server, so we must resolve travels_server_url for the operatorCode first and
 * build the OAuth URL against it.
 */
export const getRazorpayOAuthUrl = (operatorCode, onSuccess=()=>{}, onFailure=()=>{}) => {
    // The url-mapping resolver keys off the last "-" segment of the userName,
    // so a synthesized userName lets us resolve purely by operatorCode.
    getServerUrlByUserName(`razorpay-${operatorCode}`, (serverUrl) => {
        if (!isValid(serverUrl) || !isValid(serverUrl.travels_server_url)) {
            onFailure(null);
            return;
        }
        const oauthUrl = `${serverUrl.travels_server_url}/api/razorpayOAuthUrl`;
        postCall(oauthUrl, { operatorCode }).then(response => {
            if (response.status === SUCCESS_STATUS) {
                onSuccess(response.payload);
            } else {
                onFailure(response);
            }
        }).catch(onFailure);
    });
}

export const getPrepaidOtaAgentIdByServerUrl = (serverUrl, userName, onSuccess=()=>{}, onFailure=()=>{}) => {
    postCall(serverUrl+GET_TRAVELS_DETAILS_FOR_DAFIDY_PREPAID_OTA_URL, {agentName:userName, operatorCode: 'DAFIDY'}).then(response => {
        if (response.status === SUCCESS_STATUS && response.payload.Status === SUCCESS_STATUS) {
            let responsePayload = {
                prepaidOtaAgentId: response.payload.Payload.agent.id,
                prepaidOtaTravelsId: response.payload.Payload.id
            }
            onSuccess(responsePayload);
        } else {
            onSuccess(null);
        }
    });
}

export const setPrepaidOtaAgentId = (server, agentId) => {
    return {
        type: SET_PREPAID_OTA_AGENT_ID,
        payload: {
            server: server,
            agentId: agentId
        }
    }
}

export const setPrepaidOtaTravelsId = (server, travelsId) => {
    return {
        type: SET_PREPAID_OTA_TRAVELS_ID,
        payload: {
            server: server,
            travelsId: travelsId
        }
    }
}